import React from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import { Menu, MenuButton, MenuItem, MenuList, MenuTextButton } from 'components/Menu';
function SelectMenu(_ref) {
  var hasAssets = _ref.hasAssets,
    hasPlaylists = _ref.hasPlaylists,
    onSelect = _ref.onSelect;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var menuId = useUniqueId();
  return /*#__PURE__*/React.createElement(Menu, {
    id: menuId
  }, /*#__PURE__*/React.createElement(MenuButton, {
    as: MenuTextButton
  }, t('actions_select_all')), /*#__PURE__*/React.createElement(MenuList, null, /*#__PURE__*/React.createElement(MenuItem, {
    onClick: function onClick() {
      return onSelect('all');
    }
  }, t('actions_select_all')), hasAssets && /*#__PURE__*/React.createElement(MenuItem, {
    onClick: function onClick() {
      return onSelect('assets');
    }
  }, t('actions_select_all_assets')), hasPlaylists && /*#__PURE__*/React.createElement(MenuItem, {
    onClick: function onClick() {
      return onSelect('playlists');
    }
  }, t('actions_select_all_playlists'))));
}
export default SelectMenu;